// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2745":"6fe530ac","5188":"51b9403c","5771":"56856ed3","6294":"747a9bfb","6693":"dbb56c26","9635":"bf26dd49"}[chunkId] + ".chunk.css";
};